import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData, graphql } from '@packages/gql/generated/shopping';
import { getEuroFromCentValue } from '../../../../helpers/getEuroFromCentValue';

const GetPriceFragment = graphql(/* GraphQL */ `
  fragment GetPriceFragment on ProductPrice {
    value
    valueOld
  }
`);

export type GetPriceProps = FragmentType<typeof GetPriceFragment>;

export const getPrice = (data: GetPriceProps) => {
  const { value, valueOld } = getFragmentData(GetPriceFragment, data);

  const price = getEuroFromCentValue(value);

  return {
    price,
    oldPrice: valueOld ? getEuroFromCentValue(valueOld) : price,
  };
};
